import React from 'react'
import { Target } from 'src/components/TargetSavings/Target'
import SEO from 'src/seo'

const TargetSavings = () => {
  return (
    <div>
      <SEO title="Target Savings" />
      <Target />
    </div>
  )
}
export { TargetSavings }
